const EnumExpressions: any = Object.freeze({
  1: "LOST",
  2: "PAUSE",
  3: "GREAT",
  4: "REW",
  5: "FF",
});

export default EnumExpressions;
